import { Mixpanel } from "./Mixpanel.js";

export default function MixpanelUnsuccess({ ...props }) {
  const { eventName, eventSource, Useremail, status } = props;
  if (eventSource == "Authentication") {
    let auth_props = { attempted_email: Useremail, $status: status };
    Mixpanel.track(eventName, auth_props);
  }
  return;
}

export { MixpanelUnsuccess };
